export const BORDER_RADIUS = 5;
export const Y_AXIS_SPACER = 20;
export const PLUS_BUTTON_SIZE = 30;
export const CONSOLIDATE_NODE_HEIGHT = 60;
